"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserInfo = exports.selectUserConfig = exports.isSuperUser = exports.isStatusLevelIncreased = exports.isProfileSectionEditingDisabled = exports.isBrokerUser = exports.isBlockTradingEnabledForUser = void 0;
var _reselect = require("reselect");
var _get = _interopRequireDefault(require("lodash/get"));
var _userPermissionsContants = require("../../constants/userPermissionsContants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var emptyArray = [];
var getUserState = function getUserState(state) {
  return state.user;
};
var isSuperUser = exports.isSuperUser = (0, _reselect.createSelector)(function (state) {
  return (0, _get["default"])(getUserState(state), 'permissions', emptyArray);
}, function (permissions) {
  return permissions.includes(_userPermissionsContants.userPermissions.superUser);
});
var isStatusLevelIncreased = exports.isStatusLevelIncreased = (0, _reselect.createSelector)(getUserState, function (user) {
  var userConfig = user.userConfig,
    selectedAccountId = user.selectedAccountId,
    accounts = user.accounts;
  var areAccountsReady = !!selectedAccountId && accounts.length > 0;
  if (!areAccountsReady) return;
  var verificationLevel = (0, _get["default"])(accounts.find(function (i) {
    return i.AccountId === selectedAccountId;
  }), 'VerificationLevel', 0);
  var levelIncreaseStatus = userConfig.some(function (configOption) {
    return configOption.Key === 'levelIncreaseStatus';
  });
  return verificationLevel > 0 || levelIncreaseStatus && verificationLevel === 0;
});
var selectUserInfo = exports.selectUserInfo = (0, _reselect.createSelector)(getUserState, function (user) {
  return user.userInfo;
});
var selectUserConfig = exports.selectUserConfig = (0, _reselect.createSelector)(getUserState, function (user) {
  return user.userConfig || emptyArray;
});
var isBrokerUser = exports.isBrokerUser = (0, _reselect.createSelector)(selectUserConfig, function (config) {
  return config.some(function (i) {
    return i.Key === 'Broker';
  });
});
var isProfileSectionEditingDisabled = exports.isProfileSectionEditingDisabled = isStatusLevelIncreased;
var isBlockTradingEnabledForUser = exports.isBlockTradingEnabledForUser = (0, _reselect.createSelector)(function (state) {
  return (0, _get["default"])(getUserState(state), 'permissions', emptyArray);
}, function (permissions) {
  return permissions.includes(_userPermissionsContants.userPermissions.submitBlockTrade) || permissions.includes(_userPermissionsContants.userPermissions.superUser);
});